import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgValetParkinginline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M26 52H4V40.613C4 37.538 5.666 36 8.999 36H41c3.334 0 5 1.538 5 4.613V52H26z",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 46a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm26 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M8 36c.642-1.407 1.642-3.74 3-7 2.037-4.89 2.5-6 7-6h14c4.5 0 4.963 1.11 7 6 1.358 3.26 2.358 5.593 3 7" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M10 52v6m30-6v6",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("circle", {
				strokeLinecap: "square",
				cx: 50.5,
				cy: 10.5,
				r: 4.5
			}),
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "square",
				d: "M48 6V3h5v3"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M42.2 36.006l1.62-16.205A2 2 0 0 1 45.81 18h9.38a2 2 0 0 1 1.99 1.801L59 38H45.5" }),
			/* @__PURE__ */ _jsx("path", { d: "M44.5 18.5l6 5.5 6-5.5" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M48 58h5a2 2 0 0 0 2-2V38h-9v18a2 2 0 0 0 2 2z",
				strokeLinecap: "square"
			})
		]
	})
});
export default SvgValetParkinginline;
